import "./index.css";

import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import styles from './style.module.css';
//import IconProvider from "../IconProvider";
//import { ARROW_DOWN_BOLD , arrowTop, ic_circle_close} from "../../../assets/index";

import { CSSTransition } from 'react-transition-group';
//import Typography from "../Typography";
import uuid from 'uuid-random';
import IconProvider from "../../design-system/lib/IconProvider";
import { arrowTop, ic_circle_close } from "../../assets";
import Typography from "../../design-system/lib/Typography";
import { Calendar } from "@amir04lm26/react-modern-calendar-date-picker";
import { StaticDateTimePicker } from '@mui/x-date-pickers/StaticDateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';


const CustomField_DateTime = ({ IconComponents, pretitle, handleIsOpen, IsItemSelected = null, closeIcon, noArrowIcon = false, ItemsList, checkSelected = "hybrid", titleOnClick, clearOnClick, clearText, data, placement, text, badgeText, title, style, className, ref, onClick, size, icon, isSelected, isRequired, onChange, textStyle }) => {
    const [isOpen, setIsOpen] = useState(false);

    const [elmId, setElmId] = useState(`"elmDrop${uuid()}`);
    const [mapZindex, setMapZindex] = useState(0);
    const [value, setValue] = useState('10:00');
    const [dynamicPlacement, setDynamicPlacement] = useState(placement || "bottomStart");



    const dropdownNode = useClickOutside(() => {
       setIsOpen(false);
    })

    const getParentWidth = React.useCallback(() => {

        let elm = document.getElementById(elmId)
        var box = elm.getBoundingClientRect();

        return box.width

    }, [elmId]);

    useEffect(() => {

        try {
            if (handleIsOpen) {
                handleIsOpen(isOpen)
            }


        } catch (error) {

        }
    }, [isOpen]);


    const openEditCustomer = React.useCallback(() => {



        if (dynamicPlacement == "topStart") {
            let elm = document.getElementById(elmId)

            var body = document.body,
                html = document.documentElement;

            var height = Math.max(body.scrollHeight, body.offsetHeight,
                html.clientHeight, html.scrollHeight, html.offsetHeight);


            var box = elm.getBoundingClientRect();

            var body = document.body;
            var docEl = document.documentElement;

            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;



            var bottom = height - box.y - 39
            var left = box.left

            console.log("dwvefewsdxs ", body.clientHeight, box.y)


            return { bottom: `${Math.round(bottom)}px`, [clientRight <= 200 ? "right" : "left"]: (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(box.left - 33)}px`) };

        } else if (dynamicPlacement == "topEnd") {
            let elm = document.getElementById(elmId)

            var box = elm.getBoundingClientRect();

            var body = document.body;
            var docEl = document.documentElement;

            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;



            var top = box.top
            var left = box.left + scrollLeft - clientLeft;


            return { top: `${Math.round(top)}px`, right: `${Math.round(clientRight)}px` };


        } else if (dynamicPlacement == "bottomStart") {
            let elm = document.getElementById(elmId)

            var box = elm.getBoundingClientRect();

            var body = document.body;
            var docEl = document.documentElement;

            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;



            var top = box.top + box.height - 32;
            var left = box.left + scrollLeft - clientLeft - 30;


            return { top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" : "left"]: (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(box.left - 33)}px`) };

        } else if (dynamicPlacement == "bottomEnd") {
            let elm = document.getElementById(elmId)

            var box = elm.getBoundingClientRect();

            var body = document.body;
            var docEl = document.documentElement;

            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;



            var top = box.top + box.height + 10;
            var left = box.left + scrollLeft - clientLeft;


            return { top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" : "left"]: (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(box.left)}px`) };
        } else {
            let elm = document.getElementById(elmId)

            var box = elm.getBoundingClientRect();

            var body = document.body;
            var docEl = document.documentElement;

            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;



            var top = box.top
            var left = box.left

            return { top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" : "left"]: (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(box.left - 33)}px`) };

        }



    }, [elmId, dynamicPlacement]);

    const getDistanceFromBottom = () => {
        const elm = document.getElementById(elmId);
        if (!elm) return 0;

        const rect = elm.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        return viewportHeight - rect.bottom;
    };


    useEffect(() => {
        if (!isOpen) return;

        const handleScroll = () => {
           // setIsOpen(false);
        };

        window.addEventListener("scroll", handleScroll, true);

        return () => {
            window.removeEventListener("scroll", handleScroll, true);
        };
    }, [isOpen]);

    return (
        <>
            <div id={elmId} onClick={() => {
                const distance = getDistanceFromBottom();

                if (distance < 350) {
                    setDynamicPlacement("topStart");
                } else {
                    setDynamicPlacement("bottomStart");
                }

                setIsOpen(prev => !prev);
            }} className={clsx(styles.tiny, className && className)}
                style={style ? style : {}} >

                {(IconComponents) && IconComponents}

                {(icon) && <IconProvider Icon={icon} size="14" />}
                {(text && !pretitle) && <span className={clsx(styles.title, textStyle && textStyle)} style={{ color: !isSelected && "rgba(128, 128, 128, 1)", fontWeight: !isSelected && "400" }}>
                    {(closeIcon && isSelected) && <IconProvider Icon={ic_circle_close} size="14" onClick={(e) => {
                        e.stopPropagation();
                        clearOnClick && clearOnClick()
                        // setCurrentValue(null);
                        // onChange(null)
                    }} />}
                    {text}
                    {(isRequired && !isSelected) && <span className={styles.isRequired}> * </span>}
                    {(badgeText) && <span className={styles.isRequired}> {badgeText} </span>}

                </span>}

                {(text && pretitle) && <span className={clsx(styles.title, textStyle && textStyle)} >
                    {(closeIcon && isSelected) && <IconProvider Icon={ic_circle_close} size="14" onClick={(e) => {
                        e.stopPropagation();
                        clearOnClick && clearOnClick()
                        // setCurrentValue(null);
                        // onChange(null)
                    }} />}
                    {pretitle && <> <span style={{ fontWeight: "400", color: "rgba(72, 72, 72, 1)", marginInlineEnd: "-3px" }}> {pretitle} | </span>{text}</>}
                    {(isRequired && !isSelected) && <span className={styles.isRequired}> * </span>}
                    {(badgeText) && <span className={styles.isRequired}> {badgeText} </span>}

                </span>}


                {(data && data.length > 0 && !noArrowIcon) && <IconProvider Icon={arrowTop} size="14" style={{ width: "14px", height: "14px" ,transform:"rotate(180deg)"}} />}

            </div>

            {(isOpen) && <CSSTransition
                in={isOpen}
                timeout={500}
                classNames="dropdown-animation"
                unmountOnExit
                onEnter={() => setIsOpen(true)}
                onExited={() => {}}
                style={openEditCustomer() ? { ...openEditCustomer(), minWidth: `${getParentWidth() - 16}px`, marginTop: "-6px", transform: "scale(0.8)", height: "418px" } : {}}

            >
                <div ref={dropdownNode} className={clsx(styles.dropdownBox, styles[dynamicPlacement])} onClick={() => { /*  setIsOpen(!isOpen) */ }} >



                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <StaticDateTimePicker defaultValue={dayjs(new Date())} ampm={false} slotProps={{
                            actionBar: { actions: [] }  // مخفی کردن کامل اکشن بار
                            , toolbar: { sx: { display: "none" } },   // مخفی کردن Toolbar

                        }} onChange={(e, context) => {
                            onChange(e.valueOf()); // timestamp به میلی‌ثانیه

                        }} />
                    </LocalizationProvider>

                    {(clearText && isSelected) && <div style={{ borderTop: "1px solid #F4F4F7", padding: "8px 0px 5px", width: "251px", transform: "scale(1.25)", marginTop: "auto" }} onClick={() => { clearOnClick && clearOnClick() }} >
                        <Typography weight="Body_Middle_Medium" text={clearText} style={{ fontSize: "13px", color: "rgba(72, 72, 72, 1)" }} />
                    </div>}

                </div>
            </CSSTransition>}
        </>


    );
};

export default CustomField_DateTime;



const useClickOutside = (handler) => {
    const domNode = useRef();
    useEffect(() => {
        try {
            const eventHandler = (event) => {
                if (!domNode?.current?.contains(event.target)) {
                    handler();
                }
                // uncomment this for dropdown close on menu click
                // handler();
            }
            document.addEventListener("mousedown", eventHandler);
            return () => {
                document.removeEventListener('mousedown', eventHandler);
            }
        } catch (error) {

        }
    });
    return domNode;
}